module.exports = __webpack_public_path__ + "img/taekwondo2.e0113dca.jpg";